export const tab = state => () => {
    return state.tab
}

export const gender = state => () => {
    return state.gender
}

export const age = state => () => {
    return state.age
}

export const noofPhotos = state => () => {
    return state.noofPhotos
}


